<script>
  import { bookingStepClicked } from './../store/fetchBookingStepClicked.js';
  import { dateFrom } from './../store/store';

  export let Status;
  export let BookingUrl;
  export let ProviderId;
  export let BusinessCode;
</script>

{#if Status === 'A' && BookingUrl}
  <a
    class="float-right bg-teal bttn bttn-primary no-underline text-white"
    href={BookingUrl}
    target="_blank"
    on:click={() =>
      bookingStepClicked({ ProviderId }, { BusinessCode }, $dateFrom)}>
    Book now
  </a>
{:else if Status === 'M' && BookingUrl}
  <a
    class="bttn bttn-outline float-right no-underline"
    href={BookingUrl}
    target="_blank">
    Visit website
  </a>
{/if}
